import { AppThunk } from '../../../store/types';
import { UserSettingEffects } from '../../../effects/userSettingEffects';
import { getAutoSpeechRate, getSpeechLangVoiceMap } from '../../../store/general/selectors';
import { textSpeaker } from '../../../effects/textSpeaker';
import { SpeechVoiceUserSelector } from '../../../effects/speechVoiceManager';
import { getUserStateStorage } from '../../../../common/utils/local-storage/user-state';
import { getDispatch } from '../../../store';
import { updateGeneralAction } from '../../../store/general/actions';

export class SpeechVoiceSelectEvents {

	public static onSave(
		lang: string,
		voice: string,
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			const speechLangVoiceMap = {
				...getUserStateStorage().getData().speechLangVoiceMap || {},
				[lang]: voice
			}
			getUserStateStorage().setSpeechLangVoiceMap(speechLangVoiceMap);
			dispatch(updateGeneralAction({speechLangVoiceMap}));

			textSpeaker.speak(
				voice,
				lang,
				null as any, null as any, null as any,null as any,
				getAutoSpeechRate(getState()),
				SpeechVoiceUserSelector.getVoice(lang)
			);
		}
	}

}
